import { useEffect, useState } from "react";

export default function CustomCursor({ ready, onClick }) {
  const [pos, setPos] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const move = (e) => setPos({ x: e.clientX, y: e.clientY });
    window.addEventListener("mousemove", move);
    return () => window.removeEventListener("mousemove", move);
  }, []);

  return (
    <div
      onClick={ready ? onClick : undefined}
      className={`fixed z-[9999] pointer-events-none
        ${ready ? "pointer-events-auto cursor-pointer" : ""}
      `}
      style={{
        left: pos.x,
        top: pos.y,
        transform: "translate(-50%, -50%)",
      }}
    >
      <div className="w-20 h-20 rounded-full bg-white text-black
        flex items-center justify-center
        text-[10px] font-mono tracking-widest
        transition-all duration-300"
      >
        {ready ? "CONTINUE" : "LOADING"}
      </div>
    </div>
  );
}
